import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { FaPhoneAlt, FaShieldAlt, FaWhatsapp, FaClock, FaCheckCircle } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import './HomeFAQ.css';

const faqs = [
  { q: 'Klima bakımının sıklığı ne olmalı?', a: 'Genel öneri yıllık periyodik bakımdır. Yoğun kullanım veya tozlu ortam varsa yılda 2 kez bakım faydalıdır.' },
  { q: 'Kombi arızalarında nasıl hızlı destek alırım?', a: '7/24 telefon ve WhatsApp hattımızdan hızlı servis talebi oluşturabilirsiniz; acil durumlar öncelikli olarak yönlendirilir.' },
  { q: 'Fiyatlandırma nasıl yapılıyor?', a: 'Basit bakım paketleri sabit fiyatlıdır; kapsamlı onarımlar yerinde ekspertiz sonrası net fiyat ile sunulur.' },
  { q: 'Servis talebi ne kadar sürede gerçekleştirilir?', a: 'Randevu yoğunluğuna bağlı olarak genelde 24 saat içinde veya belirlenen gün ve saatte ekiplerimiz sizinle olur. Acil durumlar önceliklidir.' },
  { q: 'Yedek parçalar orijinal mi?', a: 'Mümkünse üretici orijinal parçaları kullanıyoruz; aksi durumda yüksek kalite uyumlu parçalar ile değişim yapıp parça garantisi sağlıyoruz.' },
  { q: 'Ödeme seçenekleri nelerdir?', a: 'Nakit, kredi/banka kartı ve havale/eft kabul etmekteyiz. Kurumsal işlemlerde fatura ve banka ödeme seçenekleri mevcuttur.' },
  { q: 'Kombi veya klima bakımı ne kadar sürer?', a: 'Standart bakım işlemleri genelde 45–90 dakika sürer; kapsamlı onarımlar gereken durumlarda süre uzayabilir ve ön bilgi verilir.' },
  { q: 'Garanti ve fatura veriyor musunuz?', a: 'Yapılan işçilik için garanti verilir ve talep halinde fatura/kayıt verilmektedir. Parça garantileri üretici koşullarına göre değişir.' },
  { q: 'Periyodik bakım sözleşmesi veya kurumsal hizmet sunuyor musunuz?', a: 'Evet, düzenli bakım sözleşmeleri ve site/kurumlara özel hizmet paketleri sunuyoruz; detaylar için kurumsal ekibimizle iletişime geçin.' },
];

const TRUST_POINTS = [
  { icon: <FaClock />, label: '7/24 ulaşılabilir destek' },
  { icon: <FaShieldAlt />, label: 'Garantili işçilik' },
  { icon: <FaCheckCircle />, label: 'Şeffaf fiyatlandırma' },
];

const HomeFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <section className="home-faq section" aria-labelledby="faq-heading">
      <div className="faq-inner">
        <header className="faq-header">
          <span className="faq-eyebrow">Merak Edilenler</span>
          <h2 id="faq-heading" className="faq-title">
            Sık Sorulan Sorular
          </h2>
          <p className="faq-subtitle">
            Kombi, klima ve beyaz eşya servisi hakkında en çok sorulan konulara
            net ve anlaşılır yanıtlar derledik.
          </p>
        </header>

        <div className="faq-layout">
          <aside className="faq-aside" aria-label="Destek özeti">
            <div className="faq-aside-card">
              <span className="faq-aside-badge">
                <FaShieldAlt aria-hidden />
                Güvenilir Servis
              </span>
              <h3 className="faq-aside-title">Hâlâ sorunuz mu var?</h3>
              <p className="faq-aside-text">
                Aradığınız yanıtı bulamadıysanız uzman ekibimiz size yardımcı olmaya hazır.
                Tek bir arama ile randevu oluşturabilirsiniz.
              </p>

              <ul className="faq-trust-list">
                {TRUST_POINTS.map((item) => (
                  <li key={item.label}>
                    <span className="faq-trust-icon" aria-hidden>{item.icon}</span>
                    {item.label}
                  </li>
                ))}
              </ul>

              <div className="faq-aside-actions">
                <a href={SITE.phoneHref} className="btn btn-call faq-aside-btn">
                  <FaPhoneAlt className="btn-icon" aria-hidden />
                  {SITE.phoneDisplay}
                </a>
                <a
                  href={SITE.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-whatsapp faq-aside-btn faq-aside-btn--outline"
                >
                  <FaWhatsapp className="btn-icon" aria-hidden />
                  WhatsApp
                </a>
              </div>
            </div>
          </aside>

          <div className="faq-list">
            {faqs.map((f, i) => {
              const isOpen = openIndex === i;
              const indexLabel = String(i + 1).padStart(2, '0');

              return (
                <article
                  key={f.q}
                  className={`faq-card${isOpen ? ' is-open' : ''}`}
                >
                  <h3 className="faq-card-heading">
                    <button
                      type="button"
                      className="faq-trigger"
                      onClick={() => toggle(i)}
                      aria-expanded={isOpen}
                      aria-controls={`faq-panel-${i}`}
                      id={`faq-trigger-${i}`}
                    >
                      <span className="faq-index" aria-hidden>{indexLabel}</span>
                      <span className="faq-question">{f.q}</span>
                      <span className="faq-toggle" aria-hidden>
                        <FiPlus />
                      </span>
                    </button>
                  </h3>

                  <div
                    id={`faq-panel-${i}`}
                    className="faq-panel"
                    role="region"
                    aria-labelledby={`faq-trigger-${i}`}
                    aria-hidden={!isOpen}
                  >
                    <div className="faq-panel-inner">
                      <p>{f.a}</p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
